import React from "react";
import { Box, Container, Grid, ThemeProvider } from "@mui/material";

import theme from "../../../themeContent";
import CoverageHero from "./CoverageHero";
import KpiCards from "./KpiCards";
import BackupVolumeTrend from "./BackupVolumeTrend";
import CoverageBars from "./CoverageBars";
import CausesDonut from "./CausesDonut";
import CausesTrend from "./CausesTrend";
import ProblematicHosts from "./ProblematicHosts";
import FooterOps from "./FooterOps";

// Dashboard cliente do Hermes — redesign 2026-06-01.
// Hosts desativados ficam fora dos KPIs (filtrados no back).
// Tabela bruta de erros / fila de execução foram movidas pra suas rotas
// próprias — drill-down a partir dos cards desta página.
export default function HermesDashboard() {
    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth="xl" sx={{ py: 2 }}>
                <Box display="flex" flexDirection="column" gap={2}>
                    <CoverageHero />

                    <KpiCards />

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={7}>
                            <BackupVolumeTrend />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2.5}>
                            <CoverageBars dimension="vendor" title="Cobertura por vendor" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2.5}>
                            <CoverageBars dimension="type" title="Cobertura por tipo" />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <CausesDonut />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CausesTrend />
                        </Grid>
                    </Grid>

                    <ProblematicHosts />

                    <FooterOps />
                </Box>
            </Container>
        </ThemeProvider>
    );
}
